import script from "./ProjectOverview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectOverview.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__